var MutationsGeneral;
(function (MutationsGeneral) {
    MutationsGeneral["SET_LOADING"] = "setLoadingMigo";
    MutationsGeneral["SET_CONFIRMATION"] = "setConfirmationMigo";
    MutationsGeneral["SET_ERROR"] = "setErrorHandlerMigo";
    MutationsGeneral["SET_SUCCESS"] = "setSuccessMigo";
    MutationsGeneral["SET_INFORMATION"] = "setInformationMigo";
    MutationsGeneral["SET_ALLOW_SUBMIT"] = "setAllowSubmitMigo";
    MutationsGeneral["RESET_ALLOW_SUBMIT"] = "setResetAllowSubmitMigo";
    MutationsGeneral["SET_PAGE_GOODS_MIGO"] = "setPageGoodsMigo";
})(MutationsGeneral || (MutationsGeneral = {}));
export { MutationsGeneral };
